import React, { useState } from 'react';
import _ from 'lodash';

import { useSelector } from 'react-redux';
import { Field } from 'formik';
import { Grid } from '@material-ui/core';

import DocumentField from 'app/components/DocumentField';
import { LICENSE_CHAGES_TYPE, SERVICES_CODES } from 'app/config/services';

function AdditionalFiles(props) {
  const {
    values,
    valuesFormik,
    setFieldValue,
    documentsList,
    dePlaca,
    readOnly,
    // disabled,
    contextProps: { canEdit },
    errors,
  } = props;
  const [uploading, setUploading] = useState(false);

  const revisions = useSelector(state => state.revisions.revisions);
  const service = useSelector(state => state.services.details);

  const handleChangeFile = (docParam, cdTipoDocumento, values) => {
    if (!docParam.id) return;
    const file = {
      idFile: docParam.id,
      fileName: docParam.name,
    };
    file.boExcluido = docParam.boExcluido || false;
    file.boAlterado = docParam.boAlterado || false;
    if (docParam.idGdoc) file.idGdoc = docParam.idGdoc;
    if (cdTipoDocumento) file.cdTipoDocumento = cdTipoDocumento;
    const baseDocuments = valuesFormik?.documentos || values?.documentos || [];
    let documents = [...baseDocuments];

    if (valuesFormik && service.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA) {
      let key = '';
      if (valuesFormik.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO) {
        if (valuesFormik.licencaVeiculos && valuesFormik.licencaVeiculos[0].veiculoSubstituir) {
          documents = valuesFormik.licencaVeiculos[0].veiculoSubstituir.documentos;
          key = 'veiculoSubstituir';
        }
      } else {
        if (valuesFormik.licencaVeiculos && valuesFormik.licencaVeiculos[0].veiculo) {
          documents = valuesFormik.licencaVeiculos[0].veiculo.documentos;
          key = 'veiculo';
        }
      }

      let index = _.findIndex(documents, function(doc) {
        return doc.idFile === docParam.id;
      });
      if (index != null && index >= 0) {
        documents[index] = file;
      } else {
        index = _.findIndex(documents, function(doc) {
          return doc.cdTipoDocumento === cdTipoDocumento;
        });
        if (index != null && index >= 0) {
          documents[index] = file;
        } else {
          documents.push(file);
        }
      }

      const tempLicencaVeiculos = _.cloneDeep(valuesFormik.licencaVeiculos);
      if (tempLicencaVeiculos) {
        tempLicencaVeiculos[0][key].documentos = documents;
        setFieldValue('licencaVeiculos', tempLicencaVeiculos);
      }
      return;
    }

    let key = _.findIndex(documents, function(doc) {
      return doc.idFile === docParam.id;
    });
    if (key != null && key >= 0) {
      documents[key] = file;
    } else {
      key = _.findIndex(documents, function(doc) {
        return doc.cdTipoDocumento === cdTipoDocumento;
      });
      if (key != null && key >= 0) {
        documents[key] = file;
      } else {
        documents.push(file);
      }
    }
    if (values) {
      values.documentos = documents;
    }
  };

  const handleDeleteFile = (idFile, values) => {
    let documents = _.cloneDeep(values.documentos);
    const index = _.findIndex(documents, function(doc) {
      return doc.idFile === idFile;
    });

    if (valuesFormik && service.cdServico === SERVICES_CODES.LICENCA_SEGUNDA_VIA) {
      let key = '';
      if (valuesFormik.cdTipoAlteracaoLicenca === LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO) {
        if (valuesFormik.licencaVeiculos && valuesFormik.licencaVeiculos[0].veiculoSubstituir) {
          documents = valuesFormik.licencaVeiculos[0].veiculoSubstituir.documentos;
          key = 'veiculoSubstituir';
        }
      } else {
        if (valuesFormik.licencaVeiculos && valuesFormik.licencaVeiculos[0].veiculo) {
          documents = valuesFormik.licencaVeiculos[0].veiculo.documentos;
          key = 'veiculo';
        }
      }

      if (documents[index]) {
        documents.splice(index, 1);
      }

      const tempLicencaVeiculos = _.cloneDeep(valuesFormik.licencaVeiculos);
      tempLicencaVeiculos[0][key].documentos = documents;
      setFieldValue('licencaVeiculos', tempLicencaVeiculos);
      return;
    }

    if (documents[index]) {
      documents.splice(index, 1);
    }
    values.documentos = documents;
  };

  const renderDocs = () => {
    let result = null;
    if (documentsList.length > 0) {
      result = documentsList.map((doc, index) => {
        let canEditThisDoc = canEdit;
        let idFile = null;
        let idGdoc = null;
        let value = null;
        if (values?.documentos && values?.documentos.length > 0) {
          const docValues = _.find(values.documentos, ['cdTipoDocumento', doc.cdTipoDocumento]);
          if (docValues) {
            idFile = docValues.idFile;
            idGdoc = docValues.idGdoc;
            value = docValues.fileName;

            if (revisions && Object.keys(revisions).length > 0) {
              let lastKey = Object.keys(revisions).pop();
              const revision = revisions[lastKey];
              if (revision?.documentos && revision?.documentos.length > 0) {
                if (idFile) {
                  const thisDocument = _.find(revision.documentos, ['idFile', idFile]);
                  if (thisDocument?.boConformidade) {
                    canEditThisDoc = false;
                  }
                }
              }
            }
          }
        }

        return (
          <Grid item xs={12} sm={6} md={4} key={`${doc.cdTipoDocumento}-${index}`} style={{ alignSelf: 'flex-start' }}>
            <Field
              value={value}
              required={doc.boDocumentoObrigatorio}
              name={
                doc.tipoDocumento?.sgTipoDocumento
                  ? `${dePlaca} - ${doc.tipoDocumento.sgTipoDocumento}`
                  : `doc-${doc.cdTipoDocumento}`
              }
              label={doc.tipoDocumento?.nmTipoDocumento}
              id={doc.cdTipoDocumento}
              disabled={readOnly || !canEditThisDoc}
              idGdoc={idGdoc}
              idFile={idFile}
              onChangeFile={docResult => {
                handleChangeFile(docResult, doc.cdTipoDocumento, values);
                setUploading(false);
              }}
              onDeleteFile={idFile => handleDeleteFile(idFile, values)}
              uploading={uploading}
              setUpLoading={setUploading}
              component={DocumentField}
              error={errors?.documentos && !value}
            />
          </Grid>
        );
      });
    }
    return result;
  };

  return <>{renderDocs()}</>;
}

export default AdditionalFiles;
